<template>
	<!--基础信息-->
	<section class="publish-base publish-main">
		<el-form ref="form" :model="form" :rules="rules" size="small">
			<title-area title="应用名称" hint="已签署合同和已上线或已提交测评的应用不能修改应用名称">
				<el-form-item prop="appName">
					<el-input v-model="form.appName" id="appName" :disabled="hid" style="width: 320px;" maxlength="40"  placeholder="40个字符以内，只允许中文数字" />
				</el-form-item>
			</title-area>

			<title-area title="选择分类">
				<el-form-item prop="businessType">
					<el-select v-model="form.businessType" placeholder="请选择" :disabled="hid">
						<el-option v-for="item in appTypeOptions" :key="item.id" :label="item.dictionaryname" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</title-area>

			<title-area title="应用类型">

				<el-form-item prop="appLevel">
					<el-radio-group v-model="form.appLevel" :disabled="hid">
						<v-radio label="1" :src="require('../img/1.png')">校级应用</v-radio>
						<v-radio label="2" :src="require('../img/2.png')">区级应用</v-radio>
						<v-radio label="3" :src="require('../img/3.png')">区级多校</v-radio>
					</el-radio-group>
				</el-form-item>

			</title-area>

			<title-area title="群体范围">
               <el-form-item prop="rangeCheck">
				<el-checkbox-group v-model="form.rangeCheck" :disabled="hid">
					<el-checkbox class="check-list" :label="item.id" v-for="(item, index) in appRange" :key="item.id">{{item.dictionaryname}}</el-checkbox>
				</el-checkbox-group>
               </el-form-item>
			</title-area>

			<title-area title="支持客户端" :dashed="false">
			   <el-form-item prop="clientTypeArray">
				<el-checkbox-group v-model="form.clientTypeArray" :disabled="hid">
					<v-checkbox label="110001" :src="require('../img/4.png')">电脑</v-checkbox>
					<v-checkbox label="110002" :src="require('../img/5.png')">手机</v-checkbox>
					<v-checkbox label="110003" :src="require('../img/6.png')">平板</v-checkbox>
					<v-checkbox label="110004" :src="require('../img/0.png')">后台服务</v-checkbox>
				</el-checkbox-group>
               </el-form-item>
			</title-area>

		</el-form>

	</section>
</template>

<script>
	import titleArea from './title_area'
	import vRadio from './radio'
	import vCheckbox from './checkbox'

	export default {
		name: 'vBase',
		data() {
			var validateAppName = (rule, value, callback) => {
				      if((/[^0-9\u4E00-\u9FA5]/g.test(value)))
				      {
				      	callback(new Error('应用名称只允许中文及数字,限40个字符以内'));
				      }
				      else
				      {
				      	callback();
				      }
				};
			return {
				hid: false,
				hidsub: false,
				hidsubv: false,
				form: { //表单
					appName:'',
					rangeCheck:[],
					appLevel:'',
					clientTypeArray:[],
					businessType:'',
				},
				rules: { //表单的验证规则
					businessType: [
						{ required: true, message: '请选择分类', trigger: 'change' }
					],
					appName: [
						{ required: true, message: '应用名称', trigger: 'change' },{ validator: validateAppName,  trigger: 'change' },
					],
					appLevel:[
						{ required: true, message: '应用类型', trigger: 'change' }
					],
					rangeCheck:[
						{ required: true, message: '群体范围', trigger: 'change' }
					],
					clientTypeArray:[
						{ required: true, message: '支持客户端', trigger: 'change' }
					],
				},
				appTypeOptions: this.data.appTypeOptions,
				appRange: this.data.appRange,
			}
		},

		components: {
			titleArea,
			vRadio,
			vCheckbox
		},

		watch: {
			'$parent.tCloudApp': {
				handler(val) {
					this.init();
				},
				deep: true
			},
			'$parent.tCloudAppVersion': {
				handler(val) {
					this.init();
				},
				deep: true
			}
		},
		props: {
			data: {}
		},

		mounted: function() {
			this.$nextTick(function() {
				this.init()
			})
		},


		methods: {
			init() {
				this.hid = this.$parent.hid;
				this.hidsub = this.$parent.hidsub;
				this.hidsubv = this.$parent.hidsubv;
				this.form.appName = this.$parent.tCloudApp.appName;
				this.form.businessType = this.$parent.tCloudApp.businessType;
				this.form.appLevel = this.$parent.tCloudApp.appLevel;
				var arr = this.$parent.tCloudAppVersion.userScope.split(",");
        this.form.rangeCheck=[];
				if(null != arr.length && '' != arr[0])
				{
					for(var i = 0;i < arr.length;i++)
					{
						this.form.rangeCheck.push(parseInt(arr[i]));
					}
				}
				if(null != this.$parent.tCloudAppVersion.clientType && '' != this.$parent.tCloudAppVersion.clientType)
				{
					this.form.clientTypeArray = this.$parent.tCloudAppVersion.clientType.split(",");
				}

			},
			verify() { //form表单的校验结果
				let flag;
				this.$refs['form'].validate((valid) => {
					if(valid) {
						flag = true;
					} else {
						console.log('error submit!!');
						flag = false;
						return false;
					}
				});
				return {
					flag: flag,
					status: 2,
					form: this.form
				};
			},
			saveverify() { //form表单的校验结果
				return {
					flag: true,
					status: 2,
					form: this.form
				};
			},
		}
	}
</script>

<style scoped>
	.check-list {
		width: 110px;
		margin-left: 0;
		margin-right: 30px;
	}

	.check-list:last-child {
		margin-right: 0;
	}
</style>



// WEBPACK FOOTER //
// base.vue?51260744